var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrendUp = function SvgTrendUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    color: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3 17 4-4c.883-.883 1.324-1.324 1.865-1.373a1.5 1.5 0 0 1 .27 0c.541.05.982.49 1.865 1.373s1.324 1.324 1.865 1.373q.135.012.27 0c.541-.05.982-.49 1.865-1.373l5-5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 7.277s4.101-.623 4.723 0 0 4.723 0 4.723"
  })));
};
export default SvgTrendUp;